module.exports = __webpack_public_path__ + "static/email-aceeed9afb380b8ec75d6457600a7fe2.png";